/* ============================================================
   THE CORAL CONNECT — theme runtime (Shopify-wired)
   Ports the prototype's behaviour to a real theme:
   countdown · scroll reveal · nav/drawer toggles · toast ·
   cart drawer backed by the Shopify AJAX Cart API.
   Chrome is rendered by Liquid sections; this only wires behaviour.
   Cart lines are built with safe DOM methods (textContent), never
   innerHTML, so merchant-entered titles can't inject markup.
   ============================================================ */
(function () {
  "use strict";

  var T = window.tcc || {};
  var ROUTES = T.routes || { cart_add: "/cart/add.js", cart_change: "/cart/change.js", cart: "/cart.js" };
  var MONEY_FORMAT = T.moneyFormat || "${{amount}}";

  /* ---------------- CDN image retry ----------------
     Shopify's CDN 5xxes the FIRST request for an image variant it hasn't
     transcoded yet (cold cache) — the request still kicks off the transcode,
     and the next request gets the cached copy. Browsers don't cache the 5xx,
     so one delayed reload turns a broken image into a loaded one.
     Capture phase because error events don't bubble. */
  function retryImage(img) {
    var n = +(img.getAttribute("data-cdn-retry") || 0);
    if (n >= 2 || !img.src) return;
    img.setAttribute("data-cdn-retry", n + 1);
    setTimeout(function () {
      var src = img.src, srcset = img.srcset;
      img.srcset = "";
      img.src = "";
      if (srcset) img.srcset = srcset;
      img.src = src;
    }, 1500 * (n + 1));
  }
  window.addEventListener("error", function (e) {
    var t = e.target;
    if (t && t.tagName === "IMG") retryImage(t);
  }, true);

  /* ---------------- DOM helpers ---------------- */
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function attr(node, map) { for (var k in map) node.setAttribute(k, map[k]); return node; }
  // Parse a TRUSTED static SVG string into a node without innerHTML (no script execution).
  function svgNode(markup) {
    var doc = new DOMParser().parseFromString(markup, "image/svg+xml");
    return document.importNode(doc.documentElement, true);
  }
  var ICON_CART = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12A1.125 1.125 0 0 1 19.749 21H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 6.75h12.974c.576 0 1.059.435 1.119 1.007Z"/></svg>';

  /* ---------------- Money (Dawn-compatible) ---------------- */
  function formatMoney(cents) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? "," : thousands;
      decimal = decimal == null ? "." : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : "";
      return dollars + cents2;
    }
    var match = MONEY_FORMAT.match(placeholder);
    var value;
    switch (match ? match[1] : "amount") {
      case "amount_no_decimals": value = withDelimiters(cents, 0); break;
      case "amount_with_comma_separator": value = withDelimiters(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = withDelimiters(cents, 0, ".", ","); break;
      case "amount_with_apostrophe_separator": value = withDelimiters(cents, 2, "'", "."); break;
      default: value = withDelimiters(cents, 2);
    }
    return MONEY_FORMAT.replace(placeholder, value);
  }

  /* ---------------- Cart (Shopify AJAX API) ---------------- */
  function jpost(url, data) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }
  function getCart() { return fetch(ROUTES.cart, { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }); }
  function addToCart(variantId, qty) { return jpost(ROUTES.cart_add, { items: [{ id: variantId, quantity: qty || 1 }] }); }
  function changeLine(key, qty) { return jpost(ROUTES.cart_change, { id: key, quantity: qty }); }

  function buildLine(it) {
    var row = attr(el("div", "dline"), { "data-line": it.key });
    var img = attr(el("img", "dline__thumb"), { alt: "", width: "84", height: "63", loading: "lazy" });
    if (it.image) img.src = it.image;
    var mid = el("div");
    mid.appendChild(el("p", "dline__name", it.product_title));
    if (it.variant_title && it.variant_title !== "Default Title") mid.appendChild(el("p", "dline__opt", it.variant_title));
    var qty = el("div", "qty"); qty.style.marginTop = ".5rem";
    qty.appendChild(attr(el("button", null, "−"), { "data-dec": it.key, "aria-label": "Decrease" }));
    qty.appendChild(el("span", null, String(it.quantity)));
    qty.appendChild(attr(el("button", null, "+"), { "data-inc": it.key, "aria-label": "Increase" }));
    mid.appendChild(qty);
    var right = el("div", "dline__right");
    right.appendChild(el("span", "dline__price", formatMoney(it.final_line_price)));
    right.appendChild(attr(el("button", "dline__remove", "Remove"), { "data-rem": it.key }));
    row.appendChild(img); row.appendChild(mid); row.appendChild(right);
    return row;
  }

  function renderDrawer(cart) {
    var body = document.querySelector("[data-cart-body]");
    var foot = document.querySelector("[data-cart-foot]");
    if (!body || !foot) return;
    body.replaceChildren();
    foot.replaceChildren();
    if (!cart.item_count) {
      var empty = el("div", "cart-drawer__empty");
      empty.appendChild(svgNode(ICON_CART));
      empty.appendChild(el("p", null, "Your cart is empty"));
      var shop = attr(el("a", "pill", "Shop the Reef"), { href: "/collections/all" });
      empty.appendChild(shop);
      body.appendChild(empty);
      return;
    }
    cart.items.forEach(function (it) { body.appendChild(buildLine(it)); });
    var totals = el("div", "cart-drawer__totals");
    totals.appendChild(el("span", "lbl", "Subtotal"));
    totals.appendChild(el("span", "val", formatMoney(cart.total_price)));
    foot.appendChild(totals);
    foot.appendChild(el("p", "cart-drawer__tax", "Taxes & shipping calculated at checkout. Live arrival guaranteed."));
    var form = attr(el("form"), { action: ROUTES.cart, method: "post" });
    form.appendChild(attr(el("button", "pill pill--block pill--lg", "Check out"), { type: "submit", name: "checkout" }));
    foot.appendChild(form);
  }

  function updateCount(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (b) {
      b.textContent = cart.item_count;
      b.setAttribute("data-empty", cart.item_count === 0 ? "true" : "false");
    });
  }
  function refreshCart() { return getCart().then(function (c) { updateCount(c); renderDrawer(c); return c; }); }

  function openDrawer() {
    var d = document.getElementById("tcc-cart-drawer"), s = document.querySelector(".drawer-scrim");
    if (d) d.classList.add("open");
    if (s) s.classList.add("open");
  }
  function closeDrawer() {
    var d = document.getElementById("tcc-cart-drawer"), s = document.querySelector(".drawer-scrim");
    if (d) d.classList.remove("open");
    if (s) s.classList.remove("open");
  }

  /* ---------------- Toast ---------------- */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById("tcc-toast");
    if (!t) return;
    var m = t.querySelector("[data-toast-msg]");
    if (m) m.textContent = msg || "Added to cart";
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2200);
  }

  /* ---------------- Countdown ---------------- */
  function pad(n) { return n < 10 ? "0" + n : "" + n; }
  function startCountdown(elm) {
    var target = new Date(elm.getAttribute("data-target")).getTime();
    if (isNaN(target)) return;
    var clock = elm.querySelector("[data-cd-clock]");
    var expired = elm.querySelector("[data-cd-expired]");
    function set(name, val) { var n = elm.querySelector('[data-cd="' + name + '"]'); if (n) n.textContent = pad(val); }
    function render() {
      var diff = target - Date.now();
      if (diff <= 0) {
        clearInterval(timer);
        if (clock) clock.style.display = "none";
        if (expired) expired.hidden = false;
        return;
      }
      set("days", Math.floor(diff / 86400000));
      set("hours", Math.floor((diff % 86400000) / 3600000));
      set("minutes", Math.floor((diff % 3600000) / 60000));
      set("seconds", Math.floor((diff % 60000) / 1000));
    }
    var timer = setInterval(render, 1000);
    render();
  }

  /* ---------------- Reveal on scroll (transform-only) ---------------- */
  function initReveal() {
    var els = [].slice.call(document.querySelectorAll(".reveal"));
    if (!els.length) return;
    function show(e) { e.classList.add("in"); }
    if (!("IntersectionObserver" in window)) { els.forEach(show); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    var vh = window.innerHeight || 800;
    els.forEach(function (e) {
      if (e.getBoundingClientRect().top < vh + 120) show(e);
      else io.observe(e);
    });
    setTimeout(function () { els.forEach(show); }, 1200);
  }

  /* ---------------- Event delegation ---------------- */
  function wire() {
    document.addEventListener("click", function (e) {
      var t = e.target;
      var closest = function (sel) { return t.closest ? t.closest(sel) : null; };

      if (closest("[data-announce-close]")) {
        var a = closest("[data-announce]"); if (a) a.hidden = true;
        try { sessionStorage.setItem("tcc-announce", "1"); } catch (_) {}
        return;
      }
      if (closest("[data-menu-open]")) { var mm = document.getElementById("tcc-mobile-menu"); if (mm) mm.classList.add("open"); return; }
      if (closest("[data-menu-close]")) { var mm2 = document.getElementById("tcc-mobile-menu"); if (mm2) mm2.classList.remove("open"); return; }

      var cartOpen = closest("[data-cart-open]");
      if (cartOpen) { e.preventDefault(); openDrawer(); refreshCart(); return; }
      if (closest("[data-cart-close]")) { closeDrawer(); return; }

      var navTog = closest("[data-nav-toggle]");
      if (navTog) {
        e.preventDefault();
        var item = navTog.closest("[data-nav-item]");
        var wasOpen = item.classList.contains("open");
        document.querySelectorAll("[data-nav-item].open").forEach(function (n) { n.classList.remove("open"); var b = n.querySelector("[data-nav-toggle]"); if (b) b.setAttribute("aria-expanded", "false"); });
        if (!wasOpen) { item.classList.add("open"); navTog.setAttribute("aria-expanded", "true"); }
        return;
      }
      var mTog = closest("[data-m-toggle]");
      if (mTog) {
        var grp = mTog.closest("[data-m-group]");
        var open = grp.classList.toggle("open");
        mTog.setAttribute("aria-expanded", open ? "true" : "false");
        return;
      }
      if (!closest("[data-nav-item]")) {
        document.querySelectorAll("[data-nav-item].open").forEach(function (n) { n.classList.remove("open"); var b = n.querySelector("[data-nav-toggle]"); if (b) b.setAttribute("aria-expanded", "false"); });
      }

      var add = closest("[data-add]");
      if (add) {
        e.preventDefault();
        var vid = add.getAttribute("data-add");
        if (!vid) return;
        var qn = add.getAttribute("data-qty");
        add.setAttribute("aria-busy", "true");
        addToCart(vid, qn ? parseInt(qn, 10) : 1).then(function (res) {
          add.removeAttribute("aria-busy");
          if (res && res.status) { toast(res.description || "Could not add to cart"); return; }
          toast((add.getAttribute("data-title") || "Item") + " added");
          return refreshCart().then(openDrawer);
        }).catch(function () { add.removeAttribute("aria-busy"); toast("Could not add to cart"); });
        return;
      }

      var inc = closest("[data-inc]"); if (inc) { stepLine(inc.getAttribute("data-inc"), 1); return; }
      var dec = closest("[data-dec]"); if (dec) { stepLine(dec.getAttribute("data-dec"), -1); return; }
      var rem = closest("[data-rem]"); if (rem) { changeLine(rem.getAttribute("data-rem"), 0).then(function (c) { updateCount(c); renderDrawer(c); }); return; }
    });

    // Intercept real product add-to-cart forms → AJAX add + open drawer (design behaviour)
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (e.defaultPrevented || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var btn = form.querySelector('[name="add"], [type="submit"]');
      if (btn) btn.setAttribute("aria-busy", "true");
      fetch(ROUTES.cart_add, { method: "POST", headers: { "Accept": "application/json" }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (btn) btn.removeAttribute("aria-busy");
          if (res && res.status) { toast(res.description || "Could not add to cart"); return; }
          toast("Added to cart");
          return refreshCart().then(openDrawer);
        })
        .catch(function () { if (btn) btn.removeAttribute("aria-busy"); form.submit(); });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeDrawer();
        var mm = document.getElementById("tcc-mobile-menu"); if (mm) mm.classList.remove("open");
        document.querySelectorAll("[data-nav-item].open").forEach(function (n) { n.classList.remove("open"); var b = n.querySelector("[data-nav-toggle]"); if (b) b.setAttribute("aria-expanded", "false"); });
      }
    });
  }

  function stepLine(key, delta) {
    var span = document.querySelector('.dline[data-line="' + key + '"] .qty span');
    var cur = span ? parseInt(span.textContent, 10) : 1;
    var next = Math.max(0, cur + delta);
    changeLine(key, next).then(function (c) { updateCount(c); renderDrawer(c); });
  }

  /* ---------------- Boot ---------------- */
  function boot() {
    try { if (sessionStorage.getItem("tcc-announce") === "1") { var a = document.querySelector("[data-announce]"); if (a) a.hidden = true; } } catch (e) {}
    wire();
    refreshCart();
    document.querySelectorAll("[data-countdown]").forEach(startCountdown);
    initReveal();
    // Images that failed before our error listener attached (script loads late).
    document.querySelectorAll("img").forEach(function (img) {
      if (img.complete && img.naturalWidth === 0) retryImage(img);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.CORAL = { refreshCart: refreshCart, openCart: openDrawer, closeCart: closeDrawer, addToCart: addToCart, toast: toast, formatMoney: formatMoney };
})();
